export default {
  hero_title: 'プライバシーポリシー',
  hero_desc: 'AIX JAPAN株式会社は、お客様の個人情報の保護を重要な責務と認識し、\n以下のとおりプライバシーポリシーを定めます。',

  meta_title: 'プライバシーポリシー | AIX JAPAN株式会社',
  meta_description: 'AIX JAPAN株式会社のプライバシーポリシー。個人情報の取得・利用目的・第三者提供・管理・安全対策・開示請求等について定めています。',

  date_established: '制定日：2026年 4月1日',
  company_name: 'AIX JAPAN株式会社',
  rep_name: '代表取締役　鈴木 章史',

  sections: [
    { title: '1. 個人情報の取得について', content: 'AIX JAPAN株式会社（以下「当社」）は、お客様からのお問い合わせ、採用応募、サービスのご利用等に際して、お名前、メールアドレス、電話番号、会社名、その他必要な個人情報を取得いたします。個人情報の取得は、適法かつ公正な手段により行います。' },
    { title: '2. 個人情報の利用目的', content: '当社は取得した個人情報を以下の目的のために利用いたします。\n\n・お問い合わせへの対応およびご連絡\n・AIコンサルティング・DX支援サービスの提供\n・セミナー・イベントのご案内\n・採用選考に関する手続き\n・統計データの作成（個人を識別できない形式）' },
    { title: '3. 個人情報の第三者提供', content: '当社は、以下の場合を除き、お客様の事前の同意なく個人情報を第三者に提供いたしません。\n\n・法令に基づく場合\n・人の生命、身体または財産の保護のために必要がある場合\n・公衆衛生の向上または児童の健全な育成の推進のために特に必要がある場合' },
    { title: '4. 個人情報の委託', content: '当社は、利用目的の達成に必要な範囲において、個人情報の取扱いを業務委託先に委託する場合があります。この場合、当社は適切な委託先の選定を行い、委託先との間で個人情報の取扱いに関する契約を締結し、適切な管理・監督を行います。' },
    { title: '5. 個人情報の管理・安全対策', content: '当社は、取得した個人情報を正確かつ最新の状態に保ち、個人情報への不正アクセス、紛失、破壊、改ざんおよび漏洩などを防止するため、必要かつ適切なセキュリティ対策を実施いたします。' },
    { title: '6. 個人情報の保存期間', content: '当社は、個人情報を利用目的の達成に必要な期間、または法令に定められた期間において適切に保管します。保存期間が終了した個人情報は、適切な方法により速やかに削除または廃棄いたします。' },
    { title: '7. 個人情報の開示・訂正・削除等', content: 'お客様は、当社が保有する自己の個人情報について、開示、訂正、追加、削除、利用停止または消去を請求することができます。ご本人確認を行った上で、合理的な期間内に対応いたします。' },
    { title: '8. Cookieおよびアクセス解析ツールの利用', content: '当社のウェブサイトでは、サービス向上・利用状況の把握を目的として、CookieおよびGoogle Analytics等のアクセス解析ツールを使用する場合があります。これらのツールはIPアドレス等の情報を収集しますが、個人を特定するものではありません。' },
    { title: '9. プライバシーポリシーの改定', content: '当社は、法令の変更やサービス内容の変更等に伴い、本ポリシーを改定することがあります。重要な変更がある場合は、ウェブサイト上でお知らせします。' },
    { title: '10. お問い合わせ窓口', content: '個人情報に関するご相談・お問い合わせは、当社お問い合わせフォームよりご連絡ください。\n\nAIX JAPAN株式会社\n個人情報保護担当\nE-mail: management@aix-japan.co' },
  ],
};